import Bowser from 'bowser';
import { Environment } from '../enums/Environment';
import { e2e, getQuery } from './queryUtils';
export const getPlatform = () => {
    if (e2e() && getQuery().get('mobile') === 'true') {
        // Fake mobile for e2e tests
        return 'mobile';
    }
    return Bowser.getParser(navigator.userAgent).getPlatformType(true);
};
export const isTablet = () => {
    return getPlatform() === 'tablet';
};
export const isMobile = () => {
    return getPlatform() === 'mobile';
};
const isUiPlatform = (value) => new URLSearchParams(window.location.search).get('uiPlatform')?.toLowerCase() ===
    value.toLowerCase() || location.pathname.includes(`/${value.toLowerCase()}/`);
export const isIkeaApp = () => isUiPlatform('app');
export const isKiosk = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return (urlParams.get('uiPlatform')?.toLowerCase() === 'kiosk' || location.pathname.includes('/kiosk/'));
};
export const isWeb = () => !isIkeaApp() && !isKiosk();
export const getKioskId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('computerId') || null;
};
export const getEnvironment = () => {
    const baseUrl = window.location.hostname;
    const baseHref = window.location.href;
    let environment;
    if ((window.location.hostname === 'www.cte.ikeadt.com' ||
        window.location.hostname.includes('planner.cte.ikea')) &&
        (baseHref.includes('/branch/') || baseHref.includes('/pr/'))) {
        environment = Environment.VERIFICATION_PR;
    }
    else if ((baseUrl.includes('cte.ikeadt') || baseUrl.includes('planner.cte.ikea')) &&
        baseHref.includes('/latest/')) {
        environment = Environment.VERIFICATION;
    }
    else if (import.meta.env.NODE_ENV === 'development' || baseUrl.includes('localhost')) {
        environment = Environment.DEVELOPMENT;
    }
    else if (baseUrl.includes('ikea') && baseHref.includes('next')) {
        environment = Environment.PRODUCTION_NEXT_LATEST;
    }
    else {
        environment = Environment.PRODUCTION;
    }
    return environment;
};
export const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};
export const usesVirtualKeyboard = () => {
    return (getQuery().get('enableVirtualKeyboard') === 'true' ||
        (isTouchDevice() && isKiosk() && getQuery().get('origin') !== 'upptacka'));
};
export const isDevelopment = () => getEnvironment() === Environment.DEVELOPMENT;
export const isProduction = () => [Environment.PRODUCTION, Environment.PRODUCTION_NEXT_LATEST].includes(getEnvironment());
export const iOS = () => {
    return (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
        (navigator.userAgent.includes('Mac') && isTouchDevice())); // iPad on iOS 13 detection
};
export const isSafari = () => {
    const browser = Bowser.getParser(navigator.userAgent);
    return browser.satisfies({ safari: '>0' });
};
//# sourceMappingURL=platform.js.map